import React from "react"

export function fillTemplateStrings(template, vars = {}) {
  const refs = template.match(/\$\{([^\\}]*)\}/)
  if (refs && !Object.keys(vars).includes(refs[1])) {
    console.warn(`Markdown template referenced variable that does not exist: ${refs[1]}`)
    vars[refs[1]] = ""
  }

  const handler = new Function(
    "vars",
    [
      "const tagged = ( " + Object.keys(vars).join(", ") + " ) =>",
      "`" + template + "`",
      "return tagged(...Object.values(vars))"
    ].join("\n")
  )

  return handler(vars)
}

function alignTextBlock(text: string): "center" | "left" | "right" | null {
  const leftReg = new RegExp(/->/)
  const alignLeft: boolean = leftReg.test(text)
  const rightReg = new RegExp(/<-/)
  const alignRight: boolean = rightReg.test(text)
  const alignCenter: boolean = alignLeft && alignRight

  if (alignCenter) {
    return "center"
  } else if (alignLeft) {
    return "left"
  } else if (alignRight) {
    return "right"
  } else {
    return null
  }
}

// Allows parsing text nodes for alignment tokens
//  ->This text is center aligned<-
//  ->This text is left aligned
//    This text is right aligned<-
//
// Allows parsing text for image captions
// "![some image](someimages.jpeg)"
// !: This is a caption
export function parseAdditionalRules(text: string) {
  const alignText = alignTextBlock(text)
  const captionReg = new RegExp(/^(?:\n)*(?:->)*(?:\n)*\!\:\s/)
  const isCaption = captionReg.test(text)

  if (alignText !== null || isCaption) {
    let newText = text.replace("->", "").replace("<-", "")
    let className = ""
    const styles: any = {
      display: "inherit",
      textAlign: alignText !== null ? alignText : "inherit"
    }

    if (isCaption) {
      className = "image-caption"

      // remove the caption symbol '!: '
      newText = newText.replace(captionReg, "")
    }

    return (
      <span className={className} style={styles}>
        {newText}
      </span>
    )
  }

  return text
}
